<template>
  <div>
    Filter Todos:
    <select @change="filterTodos($event)">
        <option value="200">200</option>
        <option value="150">150</option>
        <option value="100">100</option>
        <option value="50">50</option>
    </select>
  </div>  
</template>

<script>

import {mapActions} from 'vuex'

export default {
    name:'FilterTodos',

    methods: mapActions(['filterTodos'])
}
</script>


<style>

select {
  margin-top: 20px;
  padding: 6px;
  border: #d6e478 1px solid;
}
</style>